import React from 'react';

const Artist = ({ artist }) => {
  if (!artist) {
    return null;
  }

  return (
    <div className="artist">
      <img
        src={artist.picture_medium}
        alt={artist.name}
        className="artist-image"
      />

      <h3>{artist.name}</h3>

      <p>{artist.nb_fan} fans</p>
    </div>
  );
};

export default Artist;